import React, {useCallback, useEffect, useRef, useState} from 'react';

import Screen from '../../../Screen';
import QuestionFooter from '../../common/QuestionFooter/QuestionFooter';
import QuestionHeader from '../../common/QuestionHeader/QuestionHeader';

const TextAnswer = props => {
    const {answerAgain, onCancelAnswerAgain, onVote} = props,
        [answer, setAnswer] = useState(''),
        ref = useRef();

    const handleVote = useCallback(() => {
            if (answer.length) {
                onVote(null, answer);
            }
        }, [answer]),
        handleChange = useCallback(e => {
            setAnswer(e.target.value);
        }, []);

    const header = <QuestionHeader {...props} />,
        footer = (
            <QuestionFooter {...props} onVote={handleVote} disabled={!answer.length} answerAgain={answerAgain} onCancelAnswerAgain={onCancelAnswerAgain} />
        );

    useEffect(() => {
        setTimeout(() => ref.current?.focus(), 0);
    }, []);

    return (
        <Screen header={header} footer={footer} className="LiveVoting">
            <div className="content fill-container">
                <textarea className="fill-container form-control" value={answer} onChange={handleChange} />
            </div>
        </Screen>
    );
};

export default TextAnswer;
